export enum SystemMessagesEnum {
  BusinessDate = 17,
  All = 41,
  VisitorReportShows = 249,
  NextDay = 250,
  PreviousDay = 251,
  CurrentBusinessDate = 524,
  LogOut = 1501,
  Row = 60,
  RowQuantity = 32153,
  Venues = 32025,
  Events = 32026,
  Name = 516,
  ShortName = 32033,
  DisplayName = 32034,
  IsActive = 32035,
  Capacity = 32036,
  Time = 32023,
  Select = 32024,
  Status = 32022,
  OperationFailed = 32030,
  RouteNotAllowed = 32445, // Route not allowed!
  NoMenuItems = 32464, // No menu is available for your user. Please contact your system administrator.
  OperationSuccessfullyCompleted = 32065,
  CustomerValidationFailedInvalidPassword = 16134,
  Information = 32044,
  Projector = 32045,
  GeneralSettings = 32046,
  Left = 32050,
  Right = 32051,
  Middle = 32062,
  NothingToSee = 32063,
  Price = 513,
  InvalidNumericFormat = 16006,
  InvalidData = 32067,
  IsDeleted = 32068,
  Quality = 32091,
  Manually = 32093,
  Description = 32145,
  HasOverride = 32417,
  ChildSeat = 32325,
  ArmChair = 32326,
  BedLeftSide = 32327,
  BedRightSide = 32328,
  SofaLeftSide = 32329,
  SofaRightSide = 32330,
  LongSofaLeftSide = 32331,
  LongSofaRightSide = 32332,
  ReclinerChair = 32333,
  DoubleSeatLeft = 32334,
  DoubleSeatRight = 32335,
  GroupLeft = 32336,
  GroupRight = 32337,
  SiteName = 502,
  HomeOfficeSite = 66,
  PopulateNew = 95,

  /* Seats */
  Seats = 32047,
  EditSeats = 32048,
  LoveSeat = 32049,
  Handicap = 32052,
  Erased = 32053,
  HandicapsSeat = 32054,
  HandicapsAccompanyingSeat = 32055,
  RightLoveSeat = 32056,
  MiddleLoveSeat = 32057,
  LeftLoveSeat = 32058,
  ComfortSeat = 32060,
  VibrateSeat = 32061,
  Quantity = 514,
  NumericAlpha = 32449,
  Numeric = 32071,
  Numeric2Digits = 32072,
  AlphaSingle = 32073,
  AlphaDouble = 32074,
  AlphaNumeric = 32075,
  FrontToRearCenterToEdge = 32076,
  FrontToRearRightToLeft = 32077,
  FrontToRearLeftToRight = 32078,
  RearToFrontCenterToEdge = 32079,
  RearToFrontRightToLeft = 32080,
  RearToFrontLeftToRight = 32081,
  RightToLeft = 32082,
  LeftToRight = 32083,
  Spiral = 32084,
  TheStartingValueMustBeNumeric = 32085,
  TheStartingValueMustHaveTwoDigits = 32086,
  TheStartingValueMustBeOneCharacter = 32087,
  TheStartingValueMustBeTwoCharacters = 32088,
  TheStartingValueMustBeOneCharacterAndOneDigit = 32090,
  TheStartingValueMustBeStartWithDigitsAndOneCharacter = 32450,

  LinkTOECOM = 32451,

  /*actions*/
  Actions = 32070,
  Yes = 1,
  No = 2,
  Date = 3,
  Edit = 4,
  New = 5,
  Delete = 6,
  Update = 7,
  Reset = 8,
  Back = 9,
  Close = 10,
  Confirm = 32027,
  Cancel = 16108,
  Next = 63,
  Confirmation = 32028,
  Choose = 32020,
  LoadingData = 32029,
  Save = 32069,
  Print = 32183,
  Refresh = 32184,
  Remove = 32185,
  AreYouSureLogOut = 32413,
  Ok = 32436,
  RefreshDialogContent = 16225,
  Clear = 32434,
  ExportAllColumns = 32438,
  ExportOnListColumns = 32439,
  ExportSelectedColumns = 32437,
  Export = 32444,
  Event = 32040,

  AnotherShoppingCartLocksSvReference = 12191,
  AnotherShoppingCartLocksReservation = 12192,

  /* Months */
  January = 111,
  February = 112,
  March = 113,
  April = 114,
  May = 115,
  June = 116,
  July = 117,
  August = 118,
  September = 119,
  October = 120,
  November = 121,
  December = 122,

  /*Weekdays*/
  Sun = 28,
  Mon = 29,
  Tue = 30,
  Wed = 31,
  Thu = 32,
  Fri = 33,
  Sat = 34,

  /*date time*/
  StartDate = 15,
  EndDate = 16,

  /*business*/
  DistributorName = 106,

  /* Password Policy*/
  MissingUpperCase = 801,
  MissingLowerCase = 802,
  MissingNumbers = 803,
  LengthError = 804,
  InsufficientFunds = 902,

  /* List Form */
  AddRow = 32186,
  EditTable = 32187,
  NewAdjustment = 32188,
  CloseNew = 32189,
  NewCount = 32190,
  SubmitPendingChanges = 32191,
  ExitEditMode = 32192,
  ColumnsSelected = 32193,
  ChooseColumns = 32194,
  EditRow = 32195,
  Available = 32196,
  Selected = 32197,
  Search = 48,
  SearchByName = 32198,
  CopyExist = 32199,
  Submit = 32200,
  DeleteConfirmation = 32201,
  DoYouWantToDeleteTheseRecords = 32202,
  TheRecordWasRemovedSuccessfully = 32203,
  TheRecordWasNotRemoved = 32204,
  TheRecordWasSubmittedSuccessfully = 32205,
  TheRecordWasAddedSuccessfully = 32206,
  AddRowToTheSelectedSite = 32207,
  SiteNotFound = 32208,
  Details = 32323,
  TotalPages = 32324,
  RowNumber = 32414,
  ColumnName = 32415,
  RequiredFields = 32416,
  FieldIsRequired = 32429,
  IncorrectValueIntoField = 32417,
  SystemIsFailedtoAddRecord = 32418,
  SystemIsFailedtoUpdateRecord = 32419,
  DuplicateValue = 32420,
  SystemIsFailedtoDeleteDueToReference = 32421,
  Finish = 32422,
  CurrentlyOnlyPNGandJPGSupported = 32423,
  SupportPNGImagesOnly = 32461,
  SelectSite = 32446,
  WeekDay1 = 228,
  WeekDay2 = 229,
  WeekDay3 = 230,
  WeekDay4 = 231,
  WeekDay5 = 232,
  WeekDay6 = 233,
  WeekDay7 = 234,
  IsNegative = 32463,

  /* Form Field Class */
  Class1 = 32301,
  Class2 = 32302,
  Class3 = 32303,
  Class4 = 32304,
  Class5 = 32305,
  Class6 = 32306,
  Class7 = 32307,
  Class8 = 32308,
  Class9 = 32309,
  Class10 = 32310,
  Class11 = 32311,
  Class12 = 32312,
  Class13 = 32313,
  Class14 = 32314,
  Class15 = 32315,
  Class16 = 32316,
  Class17 = 32317,
  Class18 = 32318,
  Class19 = 32319,
  Class20 = 32320,

  /* End Form Field Class */

  ClearCache = 32322,

  /* Attributes */
  FOREIGN1 = 32401,
  FOREIGN2 = 32402,
  FOREIGN3 = 32403,
  CUSTOM1 = 32404,
  CUSTOM2 = 32405,
  CUSTOM3 = 32406,
  CUSTOM4 = 32407,
  CUSTOM5 = 32408,
  CUSTOM6 = 32409,
  CUSTOM7 = 32410,
  CUSTOM8 = 32411,
  CUSTOM9 = 32412,
  ShowingGlobalChainDataFromHO = 32458,

  /* New Version */
  NewVersion = 32424,
  VersionUpdateAdmin = 32425,

  /*Navigate CRM */
  navigateCRMHeader = 32426,
  areYouSureNavigateCRM = 32427,
  unsavedDataWillBeLost = 32428,
  AreYouSureDeleteRecord = 1011,
  FileNotExisted = 16213,
  SendEmailSuccess = 16214,
  CorrectEmailAddress = 16215,
  ClearCacheSucceeded = 16216,
  ClearCacheFailed = 16217,
  ClearCacheTooManyRequests = 32462,
  // IJUMP-54 / IJUMP-21 — per-ticket customer assignment errors (MessageId = server ReturnCode)
  TicketCustomerAssignmentInvalid = 373,
  TicketCustomerAssignmentAgeMismatch = 374,
}
